import { config } from '@koolumbus/web/config';
import { createTxs } from '@koolumbus/web/utils';
import React, { useState } from 'react';
import ReactMapGL from 'react-map-gl';
import { PropertyData } from '../../../lib/models';
import MapMarker from '../../common/map/MapMarker';

interface PropertyLocationSectionProps {
  property: PropertyData;
}

const PropertyLocationSection: React.FC<React.PropsWithChildren<PropertyLocationSectionProps>> = ({
  property,
}) => {
  const {
    position: [lat, lng],
  } = property;
  const tx = useTxs();

  const [viewport, setViewport] = useState({
    width: '100%',
    height: '400px',
    latitude: lat,
    longitude: lng,
    zoom: 12,
  });

  return (
    <>
      <div className="px-6 md:px-0">
        <p className="text-gray-800 font-medium text-lg mb-4 sm:mb-6">{tx.title}</p>
      </div>

      <ReactMapGL
        mapStyle="mapbox://styles/mapbox/streets-v11"
        mapboxApiAccessToken={config.mapboxToken}
        onViewportChange={setViewport}
        className="w-full h-24 sm:rounded-md"
        {...viewport}
      >
        <MapMarker
          latitude={property.position[0]}
          longitude={property.position[1]}
          selected={false}
        />
      </ReactMapGL>
    </>
  );
};

const useTxs = createTxs({
  en: { title: 'Location on map' },
  it: { title: 'Posizione sulla mappa' },
});

export default PropertyLocationSection;
